@if (!isLoading) {
  <div>
    @if (!isEditing) {
      <mat-card class="content" appearance="outlined">
        <mat-card-content>
          @if (allowEditInfo) {
            <button
              class="editButton"
              id="editButton"
              (click)="enableEditMode()"
              mat-button
              >
              <mat-icon matTooltip="Edit">edit</mat-icon>
            </button>
          }
          <h2>Inspection Details</h2>
          <mat-list class="row-list" id="staticGeneralInfoItems">
            @for (item of staticGeneralInfoItems; track item) {
              <mat-list-item
                id="list-item-{{ item.icon }}"
                >
                <mat-icon class="icon-detail" matListItemIcon>{{
                  item.icon
                }}</mat-icon>
                <p class="title-detail" matListItemTitle>{{ item.title }}</p>
                @for (line of item.lines; track line) {
                  <p
                    class="description-detail"
                    matListItemLine
                    >
                    {{ line }}
                  </p>
                }
              </mat-list-item>
            }
          </mat-list>
          <hr class="separator" />
          <mat-list class="row-list" id="scopeOfWork">
            @for (item of scopeOfWork; track item) {
              <mat-list-item class="scope">
                <mat-icon class="icon-detail" matListItemIcon>{{
                  item.icon
                }}</mat-icon>
                <p class="title-detail" matListItemTitle>{{ item.title }}</p>
                @for (line of item.lines; track line) {
                  <p
                    class="description-detail"
                    matListItemLine
                    >
                    {{ line }}
                  </p>
                }
              </mat-list-item>
            }
          </mat-list>
        </mat-card-content>
      </mat-card>
    }
    @if (dynamicGeneralInfoItems?.length && !isEditing) {
      <mat-card
        class="additional"
        appearance="outlined"
        >
        <mat-card-content>
          <h3>Additional Info Details</h3>
          <mat-list class="row-list" id="dynamicGeneralInfoItems">
            @for (item of dynamicGeneralInfoItems; track item) {
              <mat-list-item>
                <mat-icon class="icon-info" mat-list-icon>info_24px</mat-icon>
                <p class="title-detail" mat-line>
                  {{ item.name }}
                  @if (item.mandatory) {
                    <span class="mandatory-asterisk">*</span>
                  }
                </p>
                @if (item.controlType != 1) {
                  <p
                    [innerHTML]="formatText(item.value)"
                  ></p>
                }
                @if (item.controlType == 1) {
                  <a
                    [href]="item.value"
                    target="_blank"
                    >{{ item.value }}</a
                    >
                  }
                </mat-list-item>
              }
            </mat-list>
          </mat-card-content>
        </mat-card>
      }
      <im-general-info-editable-mode
        [hidden]="!isEditing"
        [inspectionId]="inspectionId"
        [generalInfo]="generalInfo"
        (generalInfoSaved)="onGeneralInfoSaved($event)"
        (cancelEdition)="onCancelEdition()"
        >
      </im-general-info-editable-mode>
    </div>
  }

  @if (isLoading) {
    <mat-spinner diameter="32"></mat-spinner>
  }
